import * as S from './categories.styled'
import React from 'react'
import {
    $categoriesFlat,
    ICategoriesItem,
    useGroupTreeCategories,
    useSelectCategory
} from 'src/features/filter-goods/model/categories'
import { useCurrentGroupId } from '@entities/groups/model'
import { useList } from 'effector-react'

const NavItemDesktop = ({ children }: { children: ICategoriesItem }) => {
    const selectCategory = useSelectCategory()
    const currentGroupId = useCurrentGroupId()
    const selectCategoryHandler = (e: React.MouseEvent<HTMLSpanElement> | React.TouchEvent<HTMLSpanElement>) => {
        e.stopPropagation()
        if (children.level < 1) return
        selectCategory(children)
    }
    return (
        <S.NavItemContainer>
            <S.StyledLink
                onClick={selectCategoryHandler}
                isSelected={children.id === currentGroupId}
                paddingLeft={children.level * 20}>
                {children.title}{' '}
                {/*    {item.count && item.count > 0 ? <S.CountBlock>({item.count})</S.CountBlock> : <React.Fragment />}*/}
            </S.StyledLink>
        </S.NavItemContainer>
    )
}

export const FilterCategoriesDesktop = () => {
    const groupTreeCategories = useGroupTreeCategories()
    const list = useList($categoriesFlat, (category) => <NavItemDesktop>{category}</NavItemDesktop>)
    if (groupTreeCategories <= 0) return <React.Fragment />
    return (
        <S.Container>
            <S.Title>Категории</S.Title>
            {list}
        </S.Container>
    )
}
